export class CompanyMasterProperties{
    companyId:number=0;
    companyName:string;
    companyURL:string;
    companyStatus:boolean=false;
    companyCurrency:string;
}